export default __webpack_public_path__ + "blue-dot-icon.svg";